import React from 'react';

export const CheckoutErrorContext = React.createContext(null);
const Provider = (props) => {
  const { children } = props;
  const [guestCheckoutEmptyError, setGuestCheckoutEmptyError] =
    React.useState(false);
  const [reInformationEmptyError, setReInformationEmptyError] =
    React.useState(false);
  const [tcEmptyError, setTcEmptyError] = React.useState(false);
  const resetStatus = () => {
    setGuestCheckoutEmptyError(false);
    setReInformationEmptyError(false);
    setTcEmptyError(false);
  };
  return (
    <CheckoutErrorContext.Provider
      value={{
        guestCheckoutEmptyError,
        setGuestCheckoutEmptyError,
        reInformationEmptyError,
        setReInformationEmptyError,
        tcEmptyError,
        setTcEmptyError,
        resetStatus,
      }}>
      {children}
    </CheckoutErrorContext.Provider>
  );
};
export default Provider;
